import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MenuItem } from '../interfaces/menu-items.interface';

@Injectable()
export class MenuService {
  menuItems: BehaviorSubject<MenuItem[]> = new BehaviorSubject([]);
}
